export const BASE_DOMAIN = process.env.REACT_APP_API_URL;

export const MQTT_SERVER_URL = process.env.REACT_APP_MQTT_SERVER_URL;

export const MQTT_ENV = process.env.REACT_APP_MQTT_ENV;
